export default __webpack_public_path__ + "static/Chicago-eb48cd89d8990b4b79782febe9b63d5c.svg";